// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonContainer-wQ7DD{padding:10px 0}.panel-DrLia{background:#f9f9f9;padding:12px;margin-bottom:12px}", "",{"version":3,"sources":["webpack://./app/assets/javascripts/containers/PodcastListenAndSubscribe/styles.scss"],"names":[],"mappings":"AACE,uBACE,cAAA,CAGF,aACE,kBAAA,CACA,YAAA,CACA,kBAAA","sourcesContent":[":local {\n  .buttonContainer {\n    padding: 10px 0;\n  }\n\n  .panel {\n    background: #f9f9f9;\n    padding: 12px;\n    margin-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": "buttonContainer-wQ7DD",
	"panel": "panel-DrLia"
};
export default ___CSS_LOADER_EXPORT___;
